import React from "react";
import { Input } from "antd";

const SearchBox = ({ onSearch, placeholder = "Search", width = 320 }) => (
	<Input.Search
		allowClear
		enterButton
		size="large"
		placeholder={placeholder}
		onSearch={onSearch}
		style={{ width, maxWidth: "100%" }}
	/>
);

export default SearchBox;
